import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { initPostHog } from './lib/posthog';
import { initSentry } from './lib/sentry';
import ErrorBoundary from './components/ErrorBoundary';

// Initialize error tracking and analytics
initSentry();
initPostHog();

// Load Sentry test utilities in development
if (import.meta.env.DEV) {
  import('./lib/sentry-test').then(() => {
    console.log('🧪 Sentry test utilities loaded. Type window.sentryTest in console.');
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
